function Header() {
  return (
    <div id="header" className="mx-auto">
      Shortways Client Custom
    </div>
  )
}

export default Header
